/**
 * 子母划转、子账号间划转唤起资产弹窗
 */
// import { Checkbox, Input } from 'antd';
import { Checkbox, Input } from '@bfe/moly';
import { SearchIcon } from '@bfe/moly-icons';
import React from 'react';

// import SearchIcon from '@/assets/icon/search-icon.svg';
import { useI18nContext } from '@/i18n/I18n';
export function useTransferAssets() {
  const [$t] = useI18nContext();

  const getTitle = (props: any) => {
    return (
      <div
        className="sub-account-list-head"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div className="sub-account-list-title">
          <div className="show-switch-accounts-box">
            <Input
              className="search-sub-account"
              value={props.searchAccountName}
              placeholder={$t('child.loginName')}
              prefix={
                <span
                  style={{
                    display: 'inline-flex',
                    padding: '0 4px 0 8px',
                    color: 'var(--bds-gray-t2)',
                  }}
                >
                  <SearchIcon />
                </span>
              }
              maxLength={20}
              onChange={(e) => {
                props.setSearchAccountName?.(e.target.value);
              }}
              size="middle"
              onKeyDown={(e: any) => {
                if (e?.keyCode === 13 || e?.which === 13) {
                  props.onSearchSubAccount?.(e.target.value);
                }
              }}
            />
            <Checkbox
              checked={props.switchListChecked}
              size="small"
              onChange={(e) => {
                props.setSwitchListChecked(e.target.checked);
                props.refreshTable('show-allow-switch-accounts', {
                  switchListChecked: e.target.checked,
                });
              }}
            >
              {$t('child.showSwitchAccounts')}
            </Checkbox>
          </div>
        </div>
      </div>
    );
  };

  const MemorizedTitle = React.useCallback(getTitle, [$t]);

  return {
    MemorizedTitle,
  };
}
